module.exports = __webpack_public_path__ + "img/hohlschnitt_silbergrau_ral9006.50bf5e6e.jpg";